export const getEnumName = (
  enumObj: Record<string, string | number>,
  value: number,
): string => {
  return (
    Object.keys(enumObj).find((key) => enumObj[key] === value) || "UNKNOWN"
  );
};
